import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../index.css";
import { Button, DropDownField } from "../../../helpers";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { updateBuyerQuote } from "../../../services/api/buyerQuote";


const QuoteClosureReasonModal = (props) => {
    const { buyerQuote, updateBuyerQuoteState } = props

    const dispatch = useDispatch()
    let quoteClosureReasons = useSelector(state => state.common.buyerQuoteClosureReasonList)

    console.log("quoteClosureReasons2", quoteClosureReasons)
    const [quoteClosureReasonId, setQuoteClosureReasonId] = useState(buyerQuote.quoteClosureReasonId)

    const handleSelectReasonChange = (e)=>{
        setQuoteClosureReasonId(e.target.value)
    }

    const handleSubmitReason = async ()=>{
        if(quoteClosureReasonId){
            const data = {
                quoteClosureReasonId: quoteClosureReasonId
            }
            const updateBuyerQuoteClosureReason = await updateBuyerQuote(buyerQuote.buyerQuoteId, data)
            if(!updateBuyerQuoteClosureReason?.failure){
                updateBuyerQuoteState({...buyerQuote, ...data})
                dispatch(raiseToast({severity:'success', detail: "Closure reason has been added successfully." , life: 3000}))
            }else{
                dispatch(raiseToast({severity:'warn', detail: "Something went wrong. please try again!" , life: 3000}))
            }
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Please select reason." , life: 3000}))
        }
    }

    return (
        <div className="flex flex-column pb-2 mb-2">
            <DropDownField labelText="Select reason" value={quoteClosureReasonId} options={quoteClosureReasons} optionLabel="quoteClosureReason" optionValue="quoteClosureReasonId" onChange={handleSelectReasonChange} disabled={buyerQuote.quoteClosureReasonId} required/>
            <div className="flex flex-row justify-content-end mt-5">
                <Button className="mt-5" label="Submit" onClick={handleSubmitReason} disabled={buyerQuote.quoteClosureReasonId} />
            </div>
        </div>
    )
};

export default QuoteClosureReasonModal;